import CategoryIcon from "@components/CategoryIcon";
import { Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

import ArrowRight from "@/assets/common/other_icons/arrow-right-solid.svg?react";
import { cn } from "@/utils/classes";

function ReviewCategoryItem({
  url,
  categoryKey,
  carbonToDisplay,
  carbonUnit,
  variant = "default",
  onHover,
}: {
  url: string;
  categoryKey: string;
  carbonToDisplay: string;
  carbonUnit: string;
  variant?: "default" | "highlighted";
  onHover?: (key: string | undefined) => void;
}) {
  const { t } = useTranslation(["reviewCategories", "common"]);

  return (
    <li>
      <a
        href={url}
        className={cn(
          "mb-2xs gap-2xs border-grayscale-xx-light px-xs py-2xs hover:border-grayscale-x-light group flex flex-row items-center rounded-lg border shadow-sm transition-all hover:ease-out active:border-transparent active:ease-in",
          variant === "highlighted" ? "border-grayscale-x-light" : ""
        )}
        onMouseEnter={() => (onHover ? onHover(categoryKey) : undefined)}
        onMouseLeave={() => (onHover ? onHover(undefined) : undefined)}
      >
        <CategoryIcon name={categoryKey} />

        <Typography step="-1" className="grow">
          {t(`reviewCategories:${categoryKey}`)}
        </Typography>
        <Typography step="-1">
          {carbonToDisplay}
          &nbsp;
          {t(`common:unit.${carbonUnit}`)}
        </Typography>
        <ArrowRight
          className={cn(
            "size-sm group-hover:fill-secondary inline-block",
            variant === "highlighted" ? "fill-secondary" : ""
          )}
        />
      </a>
    </li>
  );
}

export default ReviewCategoryItem;
